import React, { useEffect, useState } from "react";
import { Editor, Frame } from "@craftjs/core";

// Your components
import { Container } from "../user/Container";
import { Text } from "../user/Text";
import { Button } from "../user/Button";
import { Image } from "../user/Image";
import { FeatureSection } from "../user/FeatureSection";
import { ResponsiveContainer } from "../user/ResponsiveContainer";
import { HeaderSection } from "../sections/HeaderSection";
import { HeroSection } from "../sections/HeroSection";
import { WhyChooseUs } from "../sections/WhyChooseUs";
import { TestimonialsSection } from "../sections/TestimonialsSection";
import { CTASection } from "../sections/CTASection";
import { FooterSection } from "../sections/FooterSection";

// Styles for landing page + preview tweaks
import "../../styles/landing.css";
import "../../styles/components/preview/PreviewPage.css";

const resolver = {
  Container,
  Text,
  Button,
  Image,
  FeatureSection,
  ResponsiveContainer,
  HeaderSection,
  HeroSection,
  WhyChooseUs,
  TestimonialsSection,
  CTASection,
  FooterSection,
};

const PreviewPage: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let raw = localStorage.getItem("craftjs-demo");

    if (!raw) {
      const params = new URLSearchParams(window.location.search);
      raw = params.get("state") || null;
      if (raw) raw = decodeURIComponent(raw);
    }

    if (!raw && window.opener && (window.opener as any).editor) {
      try {
        const json = (window.opener as any).editor.query.serialize();
        raw = JSON.stringify(json);
      } catch {
        raw = null;
      }
    }

    if (!raw) {
      setError("No saved page found. Please save your design first.");
    } else {
      try {
        setData(JSON.parse(raw));
      } catch {
        setError("Failed to parse saved page data.");
      }
    }

    setLoading(false);
  }, []);

  if (loading) return <div className="preview-loading">Loading…</div>;
  if (error) return <div className="preview-error">{error}</div>;

  return (
    <div className="preview-page">
      {/* Editor shell is disabled and pointer-events turned off */}
      <Editor resolver={resolver} enabled={false}>
        {/* Frame wrapper has pointer-events re-enabled */}
        <Frame data={data}>
          <div className="preview-placeholder">
            {/* If something goes wrong, this shows */}
          </div>
        </Frame>
      </Editor>
    </div>
  );
};

export default PreviewPage;
